export const redirectTo = {
  PUBLICA: (basename) =>
    (window.location.href = `https://consignet.app-csg.com.br/${basename}`),
  PRIVADA: (basename) =>
    (window.location.href = `https://mixtra.app-csg.com.br/${basename}`),
  DEV: (basename) =>
    (window.location.href = `http://localhost:5000/${basename}`),
  HOMOLOG: (type, number, basename) =>
    (window.location.href = `https://homolog${number}-${type}.app-csg.com.br/${basename}`),
  IMPLANTACAO: (type, basename) =>
    (window.location.href = `https://implantacao-${type}.app-csg.com.br/${basename}`),
};
